import { Tag } from 'antd';
import { useContext } from 'react';
import UiContext from '../../../lib/UiContext';
const SchoolInfoHeader = ({
  ChildComponent
}) => {
  const uiContext = useContext(UiContext);
  const queryParams = {
    id: uiContext.entity.id,
    startDate: uiContext.dateSpan.from.format('YYYY-MM-DD'),
    endDate: uiContext.dateSpan.to.format('YYYY-MM-DD')
  };
  const menu = [{
    key: 'overview',
    title: 'Overview',
    link: {
      pathname: `/reports/school/overview`,
      query: queryParams
    }
  }, {
    key: 'leaderboard',
    title: 'Leaderboard',
    children: [{
      key: 'classes',
      title: 'Classes',
      link: {
        pathname: `/reports/school/leaderboard`,
        query: {
          ...queryParams,
          view: `classes`
        }
      }
    }, {
      key: 'students',
      title: 'Students',
      link: {
        pathname: `/reports/school/leaderboard`,
        query: {
          ...queryParams,
          view: `students`
        }
      }
    }]
  }, {
    key: 'usage',
    title: 'Usage',
    icon: false,
    link: {
      pathname: `/reports/school/usage`,
      query: queryParams
    }
  }, {
    key: 'proficiency',
    title: 'Proficiency',
    link: {
      pathname: `/reports/school/proficiency`,
      query: queryParams
    }
  }, {
    key: 'growth',
    title: 'Growth',
    link: {
      pathname: `/reports/school/growth`,
      query: queryParams
    }
  }, {
    key: 'progress',
    title: 'Progress',
    link: {
      pathname: `/reports/school/progress`,
      query: queryParams
    }
  }];
  const breadcrumbs = [<>
      {uiContext.entity.district.name}, {uiContext.entity.district.state.abbreviation}
      {uiContext.entity.district.isMic && <Tag color="green">MIC</Tag>}
    </>];
  const title = [`${uiContext.entity.type?.split('_').map(w => `${w[0]}${w.slice(1).toLowerCase()}`).join(' ') || uiContext.entity.__typename} School: ${uiContext.entity.name}`];
  const props = {
    menu,
    breadcrumbs,
    title
  };
  return <ChildComponent {...props} data-sentry-element="ChildComponent" data-sentry-component="SchoolInfoHeader" data-sentry-source-file="School.jsx" />;
};
export default SchoolInfoHeader;